import { useActiveClinic } from '@/lib/activeClinic';
import { useAuth } from '@/lib/auth';
import { JournalPhrasesManager } from '@/components/journal/JournalPhrasesManager';
import { Card } from '@/components/ui/Card';

export function JournalPhrases() {
  const { activeClinicId } = useActiveClinic();
  const { hasPermission } = useAuth();
  const canAdminAll = Boolean(
    activeClinicId && hasPermission(activeClinicId, 'journal_phrases', 'delete'),
  );

  return (
    <Card className="min-w-0">
      <JournalPhrasesManager
        clinicId={activeClinicId}
        scope={canAdminAll ? 'admin' : 'clinician'}
        showPageChrome
      />
    </Card>
  );
}
